import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
} from '@mui/material';
import { useSystemModules } from 'features/systemModules/api/getSystemModules';

interface Props {
  traceMode: number;
  handleTraceModeChanged: (event: SelectChangeEvent<string>) => void;
}

const TraceModeSelector = ({ traceMode, handleTraceModeChanged }: Props) => {
  const { data: modules } = useSystemModules({});

  return (
    <FormControl variant='outlined' style={{ minWidth: 90 }} fullWidth>
      <InputLabel id='trace-mode-select-label'>Trace Mode</InputLabel>
      <Select
        labelId='trace-mode-select-label'
        id='trace-mode-select'
        name='trace_mode'
        label='Trace Mode'
        value={'' + traceMode}
        onChange={handleTraceModeChanged}
      >
        <MenuItem key={0} value={0}>
          Spectrum
        </MenuItem>
        <MenuItem key={1} value={1}>
          Spectrogram
        </MenuItem>
        {modules?.ADVANCED_HISTORY && (
          <MenuItem key={2} value={2}>
            Trendline
          </MenuItem>
        )}
      </Select>
    </FormControl>
  );
};

export default TraceModeSelector;
